import { Service } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Service()
export class StatusIncidentBarStateService {
  private visibleSubject = new BehaviorSubject<boolean>(false);
  visible$: Observable<boolean> = this.visibleSubject.asObservable();

  setVisible(visible: boolean): void {
    this.visibleSubject.next(visible);
  }
}
